let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("32IHi")).then(() => parcelRequire('5gPIW'));